import api from "@/lib/api";

// Loads stock first (short edge cache), then the store payload with ?v=<catalog version>.
// A new catalog version = a new URL = a fresh Cloudflare entry, so no purging is needed.
export async function fetchStoreWithStock(username) {
  const u = (username || "").toLowerCase();

  let stock = null;
  try {
    stock = (await api.get("/public/store-stock", { params: { u } })).data;
  } catch (e) {
    stock = null; // best-effort: stock is still enforced at checkout
  }

  const params = { u };
  if (stock && stock.version) params.v = stock.version;

  const { data } = await api.get("/public/store", { params });

  const stockMap = {};
  ((stock && stock.products) || []).forEach((p) => {
    stockMap[p.id] = p;
  });

  return { store: data, stockMap };
}